module.exports = __webpack_public_path__ + "img/sleep-pink.161187e3.svg";